import { filter } from 'lodash'

export default {
  filterAddresses () {
    return filter(this.addresses, { deleted_at: null })
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/index/resources/computed.js